import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const getVisitorSectors = () => AxiosClient.get(`/share`);
const getVisitorProjectsSectorWise = (params, query) => AxiosClient.get(`/share/${params.label}`, { ...query });
const getVisitorProjectDetails = (params) => AxiosClient.get(`/share/${params.label}/project/${params.projectId}`);

export {
    getVisitorSectors,
    getVisitorProjectsSectorWise,
    getVisitorProjectDetails
}